import template from './reci-address-checker-rule.html.twig';

const {Component} = Shopware;

Component.extend('reci-address-checker-rule', 'sw-condition-base', {
    template,
    computed: {
        selectValues() {
            return [
                {
                    label: this.$tc('reci-address-checker.options.1'),
                    value: "CERTIFIED"
                },
                {
                    label: this.$tc('reci-address-checker.options.2'),
                    value: "USABLE"
                },
                {
                    label: this.$tc('reci-address-checker.options.3'),
                    value: "FIXED"
                },
                {
                    label: this.$tc('reci-address-checker.options.4'),
                    value: "UNUSABLE"
                },
                {
                    label: this.$tc('reci-address-checker.options.5'),
                    value: "COMPROMISED"
                },
            ];
        },
        fieldNames() {
            return ['isResponseValue'];
        },
        operators() {
            return this.conditionDataProviderService.getOperatorSet('string');
        },
        isResponseValue: {
            get() {
                this.ensureValueExist();
                return this.condition.value.isResponseValue;
            },
            set(isResponseValue) {
                this.ensureValueExist();
                this.condition.value = {...this.condition.value, isResponseValue};
            }
        },
    },
});
